// extracted by mini-css-extract-plugin
export default {"modalOverlay":"qD-z","modalContent":"rD-z","header":"sD-z","close":"tD-z"};